import PublicLayout from '../layouts/PublicLayout'
import StandingsTable from '../components/StandingsTable'
import Monogram from '../components/Monogram'
import usePoll from '../hooks/usePoll'

function fieldLabel(field) {
  return field ? `Campo ${field}` : ''
}

export default function Standings({ currentEdition, editions, groups = [], liveMatch, upcoming = [], finalKickoff }) {
  usePoll(15000)
  return (
    <PublicLayout currentEdition={currentEdition} editions={editions} active="classificacoes">
      <div className="grid">
        <div>
          <div className="sechead">
            <h2>Fase de Grupos</h2>
            <div className="rule"></div>
            <span className="note">classificação ao vivo</span>
          </div>

          <div className="tables">
            {groups.map((g) => (
              <StandingsTable key={g.name} name={g.name} rows={g.rows} />
            ))}
          </div>

          <div className="legend">
            <span><i style={{ background: '#0c5132' }}></i>Apura para meias-finais</span>
            <span><i style={{ background: '#bb8a2c' }}></i>Disputa de lugares</span>
            <span className="crit">
              Desempate: confronto direto · diferença de golos · golos marcados
            </span>
          </div>
        </div>

        <div className="rail">
          {liveMatch && (
            <div className="live-card">
              <div className="tag"><span className="d"></span>Em campo · {fieldLabel(liveMatch.field)}</div>
              <div className="where">{liveMatch.time}</div>
              <div className="sc">
                <div className="t">
                  {liveMatch.home && <Monogram team={liveMatch.home} size={36} />}
                  <span>{liveMatch.home ? liveMatch.home.shortName : liveMatch.label}</span>
                </div>
                <div className="res">
                  {liveMatch.homeScore ?? 0}–{liveMatch.awayScore ?? 0}
                </div>
                <div className="t">
                  {liveMatch.away && <Monogram team={liveMatch.away} size={36} />}
                  <span>{liveMatch.away && liveMatch.away.shortName}</span>
                </div>
              </div>
            </div>
          )}

          <div className="next">
            <h3>A seguir</h3>
            <ul>
              {upcoming.map((m) => (
                <li key={m.gameNumber}>
                  <span className="h">{m.time}</span>
                  <span className="vs">
                    {m.home && m.away ? (
                      <>
                        {m.home.shortName} <em>vs</em> {m.away.shortName}
                      </>
                    ) : (
                      m.label
                    )}
                  </span>
                  {m.field && <span className="cp">Campo {m.field}</span>}
                </li>
              ))}
            </ul>
          </div>

          {finalKickoff && (
            <div className="champ">
              <div className="lab">🏆 Troféu em jogo</div>
              <div className="big">Final · {finalKickoff}</div>
            </div>
          )}
        </div>
      </div>
    </PublicLayout>
  )
}
